import InfoCircle from "../Reusable Elements/InfoCircle";

export default function PaymentPlans({ background }) {
    const paymentPlanPoints = [
        { heading: "15%", text: "On booking" },
        { heading: "10%", text: "On confirmation" },
        { heading: "21", text: "Monthly installments" },
        { heading: "3", text: "Semi-annual payments" },
        { heading: "20%", text: "At possession" },
        { heading: "30%", text: "Post handover" },
    ];

    return (
        <div className={background === "dark" ? "bg-primary-blue w-full" : "bg-primary-white w-full"}>
            <div className={background === "dark" ? "font-poppins text-5xl text-primary-white font-extralight text-center pt-8 pb-12" : "font-poppins text-5xl text-primary-blue font-extralight text-center pt-8 pb-12"}>
                Payment Plan
            </div>
            <div className="flex flex-wrap justify-center gap-x-[200px] gap-y-20 pb-16 sm:px-9">
                {paymentPlanPoints.map((plan, index) => (
                    <InfoCircle
                        key={index}
                        heading={plan.heading}
                        text={plan.text}
                        variant={1}
                        color={background === "dark" ? "blue" : "white"}
                    />
                ))}
            </div>
            <div className="flex justify-center pb-8">
                <a
                    href="/Payment Plans.pdf"
                    download="Payment Plans.pdf"
                    className="font-poppins font-extralight text-2xl text-center hover:cursor-pointer"
                    style={{
                        border: background === "dark" ? "1px solid #ffffff" : "1px solid #022051",
                        borderRadius: "5px",
                        padding: "7px 20px",
                        color: background === "dark" ? "#ffffff" : "#022051",
                    }}
                >
                    Download payment plan
                </a>
            </div>
        </div>
    );
}
